import { UserSessionStore } from '@aon/aon-tws-common-ui';
import { connect } from 'react-redux';
import { BuilderLayout } from '../../components/layout/BuilderLayout';
import { IApplicationState } from '../../store';
import { NavigationActions } from '../../store/NavigationActions';
import { ActionCreators as SurveyBuilderActionCreators } from '../../store/SurveyBuilderStore';
import { SurveyNotesActionCreators } from '../../store/SurveyNotesActionCreators';
import * as SurveyStore from '../../store/SurveyStore';
import { mapStateToProps } from './Layout';

const mapAdditionalStateToProps = (state: IApplicationState) => ({
	...mapStateToProps(state),
	...state.surveyBuilder,
	...state.survey,
});

export const BuilderLayoutContainer: React.ComponentType<any> = connect(mapAdditionalStateToProps, {
	...NavigationActions,
	...SurveyBuilderActionCreators,
	...SurveyNotesActionCreators,
	...SurveyStore.ActionCreators,
	logout: UserSessionStore.logout,
})(BuilderLayout as any);
